var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[(_vm.chart_type)?_c('v-card-text',{ref:`${_vm.chart_type}_duvalChartDiv`,staticClass:"py-0",attrs:{"id":`${_vm.chart_type}_duvalChartDiv`}},[_c('canvas',{attrs:{"id":`${_vm.chart_type}_canvas`,"width":"650","height":"500"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }